/**
 * SEO Component — Per-page meta tags using react-helmet-async
 * Provides unique title, description, OG tags, Twitter Cards, canonical URL, and JSON-LD
 */
import { Helmet } from "react-helmet-async";

const SITE_NAME = "GottaSecond";
const SITE_URL = "https://gottasecond.com";
const DEFAULT_IMAGE = "https://gottasecond.com/og-image.png";
const TWITTER_HANDLE = "@gottasecond";

export function SEO({
  title,
  description,
  path = "",
  image,
  type = "website",
  noindex = false,
  jsonLd,
}) {
  var fullTitle = title ? title + " | " + SITE_NAME : SITE_NAME + " — Find & Hire Second Shooters for Photography & Videography";
  var fullUrl = SITE_URL + path;
  var img = image || DEFAULT_IMAGE;

  var robotsContent = noindex ? "noindex, nofollow" : "index, follow";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || ""} />
      <meta name="robots" content={robotsContent} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || ""} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={img} />
      <meta property="og:type" content={type} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || ""} />
      <meta name="twitter:image" content={img} />

      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
